import React from 'react'
import { FaDownload } from 'react-icons/fa'
import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'

/**
 * Props for DownloadModal component
 */
type DownloadModalProps = {
  show: boolean
  totalItems: number
  onClose: () => void
  onConfirm: () => void
}

/**
 * DownloadModal Component
 * Confirmation modal for downloading claims data
 */
export const DownloadModal: React.FC<DownloadModalProps> = ({ show, totalItems, onClose, onConfirm }) => {
  return (
    <ObModal
      show={show}
      customSize="small"
      close={onClose}
      title={<>Download file with {totalItems} claims?</>}
      modalFooter={
        <FooterStyle>
          <Button variant="secondary" width="100%" size="large" radius="rounded" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            width="100%"
            size="large"
            radius="rounded"
            contentType="text-icon"
            onClick={onConfirm}
          >
            <FaDownload /> Yes, download
          </Button>
        </FooterStyle>
      }
    >
      <ModalContent>
        <p>
          This might take a few minutes. Once your file is ready to download it will be available in the Notifications
          menu.
        </p>
      </ModalContent>
    </ObModal>
  )
}

/* ---------- Styled Components ---------- */

const ModalContent = styled.div`
  p {
    ${({ theme }) => theme.typography.m.normal}
    color: ${({ theme }) => theme.colors.neutral.neutral};
  }
`

const FooterStyle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: -webkit-fill-available;
`
